import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import HomeService from "../../../Services/HomeService";
import Swal from "sweetalert2";
import toast from "react-hot-toast";

const headLineStyle = {
  textAlign: "center",
  fontSize: "30px",
  color: "#868e96",
  margin: "15px",
  fontWeight: "bold",
};

const ManageJobPosts = () => {
  const userRole = localStorage.getItem("role");
  const userCity = localStorage.getItem("city");
  const loggedUserID = localStorage.getItem("uid");
  const [allData, setAllData] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editID, setEditID] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const jobTypes = [
    {
      value: "full-time",
      title: "Fill Time",
    },
    {
      value: "part-time",
      title: "Part Time",
    },
  ];

  const initialFormData = {
    category: "",
    jobTitle: "",
    location: "",
    salary: "",
    jobType: "",
    jobDescription: "",
  };

  const [editData, setEditData] = useState(initialFormData);

  const columns = [
    { name: "S.No.", selector: (row) => row.sln, sortable: true },
    { name: "Category", selector: (row) => row.category?.catName, wrap: true },
    { name: "Job Title", selector: (row) => row.jobTitle, wrap: true },
    { name: "Type", selector: (row) => row.jobType, wrap: true },
    { name: "Location", selector: (row) => row.location, wrap: true },
    {
      name: "Salary",
      selector: (row) => (
        <>
          <i class="fa fa-indian-rupee-sign"></i>
          {row.salary}
        </>
      ),
      wrap: true,
    },
    { name: "Description", selector: (row) => row.jobDescription, wrap: true },
    {
      name: "Status",
      cell: (row) => (
        <button
          className={`btn btn-${row.status ? "success" : "danger"}`}
          onClick={() => toggleStatus(row.id, row.status)}
        >
          {row.status ? "Active" : "Inactive"}
        </button>
      ),
    },
    {
      name: "Action",
      cell: (row) => (
        <>
          <span title="Edit" onClick={() => handleEdit(row)}>
            <i
              className="fa-solid fa-pen-to-square"
              style={{
                cursor: "pointer",
                padding: "5px",
                marginRight: "5px",
                fontSize: "1.5em",
                color: "rgb(133, 218, 79)",
                backgroundColor: "#E9F3F7",
              }}
            ></i>
          </span>
          <span title="Delete" onClick={() => handleDelete(row.id)}>
            <i
              className="fa-solid fa-trash-can text-danger"
              style={{
                cursor: "pointer",
                padding: "5px",
                marginRight: "5px",
                fontSize: "1.5em",
                color: "#477DA5",
                backgroundColor: "#E9F3F7",
              }}
            ></i>
          </span>
        </>
      ),
    },
  ];

  const toggleStatus = async (id, currentStatus) => {
    try {
      const newStatus = !currentStatus;
      await HomeService.updateJobPostStatus(id, { status: newStatus });
      toast.success("Status updated!");
      fetchAllData();
    } catch (error) {
      toast.error("Failed to update status.");
      console.error("Error updating status:", error);
    }
  };

  // Fetch categories
  const fetchCategories = async () => {
    try {
      const res = await HomeService.getJobCategory();
      if (res?.data) {
        setCategories(res.data);
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  const fetchAllData = async () => {
    setLoading(true);
    try {
      const res = await HomeService.getJobPost();
      console.log("MNH84", res);
      if (res.status) {
        const arr = res?.data?.map((ele, ind) => ({
          sln: ind + 1,
          category: ele?.category,
          jobTitle: ele?.jobTitle,
          jobType: ele.jobType,
          location: ele?.location,
          salary: ele.salary,
          status: ele?.status,
          id: ele._id,
          jobDescription: ele?.jobDescription,
        }));
        setAllData(arr);
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      console.error("Error fetching locality:", error);
      toast.error("Failed to load locality!");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllData();
  }, []);

  const handleEdit = (row) => {
    setIsEdit(true);
    const { id, ...newObject } = row;
    setEditData({ ...newObject, category: newObject?.category?._id });
    setEditID(row.id);
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Delete Job Post?",
      text: "Are you sure you want to delete this Job Post?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      confirmButtonColor: "#d33",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    });
    if (result.isConfirmed) {
      try {
        const res = await HomeService.deleteJobVacancy(id);
        if (res?.status) {
          Swal.fire("Deleted!", "Job Post has been deleted.", "success");
          fetchAllData();
        }
      } catch (error) {
        Swal.fire("Error!", "Failed to delete Job Post.", "error");
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // const data = { city: editData.city, name: editData.name };
      console.log("MMN192", editData);
      // return
      if (isEdit) {
        const res = await HomeService.updateJobPost(editID, editData);
        if (res?.status) {
          toast.success("Job details updated successfully!");
          setIsEdit(false);
          setEditData(initialFormData);
          fetchAllData();
        } else {
          toast.error(res.message);
        }
      }
    } catch (error) {
      toast.error("Failed to save locality.");
      console.error("Error saving locality:", error);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  return (
    <>
      <div className="main_wrap" style={{ marginTop: "6rem" }}>
        <div className="container-fluid">
          <div className="mt-5">
            <div style={headLineStyle} className="page-headline">
              Manage Job Posts
            </div>
            {loading ? (
              <p>Loading...</p>
            ) : (
              <>
                {isEdit ? (
                  <section className="chartBox_area">
                    <h2>View/Modify Job Details</h2>
                    <hr />
                    <form onSubmit={handleSubmit}>
                      <div className="row">
                        <div className="col-md-6 mt-3">
                          <label>
                            Category<span className="text-danger">*</span>
                          </label>
                          <select
                            className="form-control"
                            name="catName"
                            value={editData.category}
                            onChange={(e) =>
                              setEditData({
                                ...editData,
                                category: e.target.value,
                              })
                            }
                            required
                          >
                            <option value="" disabled>
                              ---Select---
                            </option>
                            {categories.map((item) => (
                              <option key={item._id} value={item._id}>
                                {item.catName}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="col-md-6 mt-3">
                          <label htmlFor="designation">
                            Job Type<span className="text-danger">*</span>
                          </label>
                          <select
                            className="form-control"
                            name="jobType"
                            value={editData?.jobType || ""}
                            onChange={(e) =>
                              setEditData({
                                ...editData,
                                jobType: e.target.value,
                              })
                            }
                          >
                            <option value="">---Select---</option>
                            {jobTypes.map((item, key) => (
                              <option key={key} value={item.value}>
                                {item.title}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div className="col-md-12 mt-3">
                          <label htmlFor="name">
                            Job Title<span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="jobTitle"
                            value={editData?.jobTitle || ""}
                            onChange={(e) =>
                              setEditData({
                                ...editData,
                                jobTitle: e.target.value,
                              })
                            }
                            placeholder="Enter Job Title"
                            required
                          />
                        </div>

                        <div className="col-md-8 mt-3">
                          <label htmlFor="name">Location</label>
                          <input
                            type="text"
                            className="form-control"
                            name="location"
                            value={editData?.location || ""}
                            onChange={(e) =>
                              setEditData({
                                ...editData,
                                location: e.target.value,
                              })
                            }
                            placeholder="Enter job location"
                          />
                        </div>
                        <div className="col-md-4 mt-3">
                          <label htmlFor="name">Salary</label>
                          <input
                            type="text"
                            className="form-control"
                            name="salary"
                            value={editData?.salary || ""}
                            onChange={(e) =>
                              setEditData({
                                ...editData,
                                salary: e.target.value,
                              })
                            }
                            placeholder="Enter offered salary"
                          />
                        </div>

                        <div className="col-md-12 mt-3">
                          <label>Description</label>

                          <textarea
                            className="form-control"
                            name="jobDescription"
                            value={editData?.jobDescription || ""}
                            onChange={(e) =>
                              setEditData({
                                ...editData,
                                jobDescription: e.target.value,
                              })
                            }
                            placeholder="Enter description"
                          ></textarea>
                        </div>
                      </div>
                      <button type="submit" className="btn btn-primary mt-3">
                        Save Changes
                      </button>
                      <button
                        type="button"
                        className="btn btn-secondary mt-3"
                        style={{ marginLeft: "11px" }}
                        onClick={() => {
                          setEditID(null);
                          setIsEdit(false);
                        }}
                      >
                        Cancel
                      </button>
                    </form>
                  </section>
                ) : (
                  <section className="chartBox_area">
                    <DataTable
                      columns={columns}
                      data={allData}
                      pagination
                      responsive
                      highlightOnHover
                    />
                  </section>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ManageJobPosts;
